export const DOCS_UI_KEY = ['DOCS_UI_KEY'];
export const GET_OPERATORS_UI = 'GET_OPERATORS_UI';
